<template>
  <v-img
    @click="openWindow()"
    href="https://defittemedewerker.nl"
    :width="width"
    :height="'40'"
    :src="require('@/assets/img/logo.svg')"
  ></v-img>
</template>

<script>
export default {
  props: {
    width: String,
    height: String,
    content: String,
  },
  methods: {
    openWindow() {
      window.open("https://defittemedewerker.nl");
    },
  },
};
</script>
